// BOOSTRAP REQUIRED
import 'NodeModules/bootstrap/js/dist/util.js';
import 'NodeModules/bootstrap/js/dist/index.js';

// BOOTSTRAP UTILITIES
import 'NodeModules/bootstrap/js/dist/alert.js';
import 'NodeModules/bootstrap/js/dist/button.js';
import 'NodeModules/bootstrap/js/dist/carousel.js';
import 'NodeModules/bootstrap/js/dist/collapse.js';
import 'NodeModules/bootstrap/js/dist/dropdown.js';
import 'NodeModules/bootstrap/js/dist/modal.js';
import 'NodeModules/bootstrap/js/dist/popover.js';
import 'NodeModules/bootstrap/js/dist/tab.js';
import 'NodeModules/bootstrap/js/dist/tooltip.js';

// PLUGINS
import 'NodeModules/@fancyapps/fancybox/dist/jquery.fancybox.js';
import 'NodeModules/jquery.cookie/jquery.cookie.js';
import 'NodeModules/featherlight/src/featherlight.js';
import 'NodeModules/featherlight/src/featherlight.gallery.js';
import 'NodeModules/flickity/dist/flickity.pkgd.js';
import 'OchsnerJS/common/plugins/_video-gallery.js';
import 'NodeModules/slick-carousel/slick/slick.min.js';
import 'nodelist-foreach-polyfill';

// COMMON
import 'OchsnerJS/common/_app.js';
import 'OchsnerJS/common/_captcha-validation.js';
import 'OchsnerJS/common/_flickity.js';
import 'OchsnerJS/common/_functions.js';
import 'OchsnerJS/common/_required.js';
import 'OchsnerJS/common/_button-stack.js';
import 'OchsnerJS/common/_button-toggle.js';
import 'OchsnerJS/common/_email-link-fix.js';
import 'OchsnerJS/common/_offcanvas.js';
import 'OchsnerJS/common/_persona.js';
import 'OchsnerJS/common/_sub-nav.js';
import 'OchsnerJS/common/_ems-banner.js';


// CUSTOM
import 'OchsnerJS/healthyyou/_app.js';
import 'OchsnerJS/www/_relentless.js';
import 'OchsnerJS/www/_app.js';
import 'OchsnerJS/common/_load-global-search.js';
import 'OchsnerJS/www/_slick.js';
import 'OchsnerJS/www/_gallery.js';
import './scss/_app.www.scss';
import 'OchsnerJS/www/_promo-blocks.js';
import 'OchsnerJS/www/_page-builder-plugins.js';
import 'OchsnerJS/www/_page-builder-custom.js';

